import { useSyncExternalStore } from 'react';

function subscribe(onStoreChange: () => void): () => void {
  if (typeof document === 'undefined') {
    return () => {};
  }
  const el = document.documentElement;
  const observer = new MutationObserver(onStoreChange);
  observer.observe(el, { attributes: true, attributeFilter: ['class'] });
  return () => observer.disconnect();
}

function getSnapshot(): boolean {
  return typeof document !== 'undefined' && document.documentElement.classList.contains('dark');
}

/**
 * True when `document.documentElement` has class `dark` (jc public theme).
 * Server snapshot is always false to match typical SSR; updates after hydrate.
 */
export function useDocumentDarkClass(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
